import { graphql } from 'relay-runtime';

export const SET_PRIMARY_ACCOUNT_MUTATION = graphql`
  mutation SetPrimaryAccountMutation($aaid: String!) {
    unified {
      account {
        setPrimaryAccount(aaid: $aaid) {
          message
          success
          errors {
            message
            code
            extensions {
              errorType
              statusCode
            }
          }
        }
      }
    }
  }
`;
